export default __webpack_public_path__ + "static/media/grid-img.f1504723.svg";